// Y axis for the weekly entries chart (build plan §5.7): the tallest week
// rounded up to a step of 2, 5, 10, 25 or 50.
//
// chartScale(counts) → { step, max, ticks }
//   step  — the rounding step picked from the peak
//   max   — the axis top (a multiple of `step`, never below the step)
//   ticks — the labelled values, ascending, from 0 to `max`
//
// Gridlines normally sit on every step. A very busy form (peak over 300)
// would get more than MAX_INTERVALS lines, so the labels thin out to every
// k-th step; the top tick is always `max`.

const MAX_INTERVALS = 6;

export const stepFor = (peak) => {
  if (peak <= 10) return 2;
  if (peak <= 25) return 5;
  if (peak <= 60) return 10;
  if (peak <= 150) return 25;
  return 50;
};

const toCount = (n) => {
  const v = Number(n);
  return Number.isFinite(v) && v > 0 ? v : 0;
};

export const chartScale = (counts = []) => {
  const peak = Math.max(1, ...counts.map(toCount));
  const step = stepFor(peak);
  const max = Math.ceil(peak / step) * step;
  const intervals = max / step;
  const tickStep = step * Math.ceil(intervals / MAX_INTERVALS);
  const ticks = [];
  for (let v = 0; max - v >= tickStep / 2; v += tickStep) ticks.push(v);
  ticks.push(max);
  return { step, max, ticks };
};

// Bar height as a percentage of the axis.
export const barPercent = (count, max) =>
  max > 0 ? Math.min(100, (toCount(count) / max) * 100) : 0;

export default chartScale;
